@if (redHeadingText) {
<h2 class="red-heading mb-0">
  {{ redHeadingText }}
</h2>
}
<div class="collapsible-block-headline">
  <h2>
    {{ title }}
    @if (k2Only) {
    <small>
      <i class="iconfont lock"></i>
      notes only visible to K2
    </small>
    }
  </h2>

  <a (click)="onExpandedChange($event)" class="toggle">
    <icon [type]="collapsed ? 'plus-lg' : 'dash-lg'"></icon>
  </a>
</div>

<markdown-editor
  [id]="'markdown-editor'"
  [ngClass]="collapsed && 'collapsed-editor'"
  [value]="_notes"
  (focusin)="onFocus()"
  (focusout)="onBlur()"
  [placeholder]="placeholder"
  [noPreview]="true"
  (valueChange)="onNotesChange($event)"
></markdown-editor>

@if (!collapsed) {
<btn
  (click)="save.emit(this.notes); changed = false"
  icon="check2"
  [loading]="loading"
>
  Save changes
</btn>
}
